
import { Component, Prop, Vue } from "vue-property-decorator";
import { formatDate, formatTabName } from "@/utils/utils";
import { TopicListItem } from "@/types/type";

@Component
export default class PostListItem extends Vue {
  @Prop(Object)
  public readonly topicDetail!: TopicListItem;

  protected render() {
    return (
      <div class="topicItem">
        <router-link
          to={{
            name: "UserInfo",
            params: { loginName: this.topicDetail.loginName }
          }}
        >
          <img src={this.topicDetail.avatarUrl} alt="avatar" />
        </router-link>
        <div class="center">
          <span class="count">
            <span>{this.topicDetail.replyCount}</span> /
            <span>{this.topicDetail.visitCount}</span>
          </span>
          <span class={["tab", { top: this.topicDetail.top }]}>
            {formatTabName(this.topicDetail)}
          </span>
          <router-link
            class="topicItemLink"
            to={{
              name: "Article",
              params: {
                id: this.topicDetail.id,
                loginName: this.topicDetail.loginName
              }
            }}
          >
            <span class="title">{this.topicDetail.title}</span>
          </router-link>
        </div>
        <span class="time">{formatDate(this.topicDetail.lastReplyAt)}</span>
      </div>
    );
  }
}
